<template>
  <div class="modal" data-backdrop="static" id="bsTagFormDialog" ref="bsTagFormDialogRef">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content viewDetails">
        <form id="saveTag" name="saveTag"
              :action="pUrls['saveTag']"
              method="post" class="ajax-support ajax-support show-waiting"
              data-ajax-support-csv="#ajaxModuleForm,#tagModuleBody,#guides-sidebar">

          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h3 class="modal-title">{{ title }}</h3>
          </div>
          <div class="modal-body max-height bs3-padding-top-reset bs3-padding-bottom-reset">

            <input type="hidden" name="dataForm.data.id" :value="data.id"/>

            <input type="hidden" name="src" :value="pSrc"/>
            <input type="hidden" name="srcId" :value="pSrcId"/>

            <div v-if="nbOfErrors > 0">
              <div class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-danger">
                <span class="label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
              </div>
            </div>

            <div class="bs3-padding-y">
              <div class="row">
                <div class="col-xs-12">
                  <!--
                   - NAME
                   --->
                  <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.name')}]">
                    <div v-if="hasFieldErrors('dataForm.data.name')">
                      <span v-for="error in getFieldErrors('dataForm.data.name')" class="help-block" :key="error">{{ error }}</span>
                    </div>
                    <label v-else for="tag_name">
                      <span class="required">*</span> {{ pDictionary['dictionary.tag.name'] }}
                    </label>
                    <input type="text"
                           id="tag_name"
                           name="dataForm.data.name"
                           v-model="data.name"
                           class="form-control"
                           :placeholder="pDictionary['dictionary.tag.name.placeholder']"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <!--
                   - DESCRIPTION
                   --->
                  <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.description')}]">
                    <div v-if="hasFieldErrors('dataForm.data.description')">
                      <span v-for="error in getFieldErrors('dataForm.data.description')" class="help-block" :key="error">{{ error }}</span>
                    </div>
                    <label v-else for="tag_description">
                      {{ pDictionary['dictionary.tag.description'] }}
                    </label>
                    <textarea
                        id="tag_description"
                        name="dataForm.data.description"
                        v-model="data.description"
                        class="form-control" rows="5"></textarea>
                  </div>
                </div>
              </div>

              <!--
                 - TAG VALUES
                 --->
              <fieldset :class="['bs3-margin-top', {'has-error': hasFieldErrors('dataForm.data.valueRefs')}]">
                <legend>
                  <i class="fa-light fa-tags"></i>
                  <span class="bs3-margin-left3">{{ pDictionary['dictionary.tag.value.plural'] }}</span>
                  <button class="btn btn-link right" @click.prevent="addTagOptions" v-show="!addTagOptionsVisible"><i
                      class="fa-light fa-plus"></i>
                    {{ 'dictionary.tag.value.add' | i18nText(pDictionary) }}
                  </button>
                </legend>
                <div class="row">
                  <div class="col-xs-12">

                    <div v-if="hasFieldErrors('dataForm.data.valueRefs')" class="bs3-margin-top">
                      <span v-for="error in getFieldErrors('dataForm.data.valueRefs')" class="help-block" :key="error">{{ error }}</span>
                    </div>

                    <tag-save-form-add-options
                        :p-dictionary="pDictionary"
                        :p-visible="addTagOptionsVisible"
                        @add-options="onAddTagOptions"
                        @cancel-add-options="onCancelAddTagOptions">
                    </tag-save-form-add-options>

                    <table class="table table-striped table-borderless-top">
                      <tbody>
                      <tr v-if="data.valueRefs.length === 0">
                        <td colspan="2"> {{ 'dictionary.general.none' | i18nText(pDictionary) }}</td>
                      </tr>
                      <tag-save-form-option
                          v-for="(optionRef, index) in data.valueRefs"
                          :key="tagOptionKey(optionRef, index)"
                          :p-data="optionRef"
                          :p-error-list="pErrorList"
                          :p-input-prefix="'dataForm.data.valueRefs[' + index + ']'"
                          :p-removable="isTagValueRemovable(optionRef)"
                          @remove-option="onRemoveOption">
                      </tag-save-form-option>
                      </tbody>
                    </table>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div class="modal-footer">
            <div class="text-right">
              <button type="submit" class="btn btn-primary" :disabled="addTagOptionsVisible">
                <i class="fa-light fa-check"></i> <span>{{ pDictionary['dictionary.actions.save'] }}</span>
              </button>
              <a href="#"
                 class="btn btn-link" data-dismiss="modal" aria-label="Cancel">{{ pDictionary['dictionary.actions.cancel'] }}</a>
            </div>
          </div>

        </form>

      </div>

    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import TagSaveFormOption from "@/components/modules/administration-module/tag/form/save/TagSaveFormOption";
import TagSaveFormAddOptions from "@/components/modules/administration-module/tag/form/save/TagSaveFormAddOptions";

export default {
  name: "TagSaveForm",
  components: {TagSaveFormAddOptions, TagSaveFormOption},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pDataForm: Object
  },
  data: function () {
    return {
      data: this.pDataForm.data,
      errorList: [],
      addTagOptionsVisible: false
    }
  },
  methods: {
    isIdValid: function () {
      return this.data.id !== undefined
             && this.data.id > 0;
    },
    tagOptionKey: function (tagValue, index) {
      return tagValue.id > 0 ? tagValue.id : -index;
    },
    isTagValueRemovable: function (tagValueRef) {
      let removable = this.pDataForm.tagValueRemovableById[tagValueRef.id];
      return removable !== undefined ? removable : true;
    },
    addTagOptions: function () {
      this.addTagOptionsVisible = true;
    },
    onAddTagOptions: function (options) {
      // Add options.
      for(let i = 0; i < options.length; i++)
      {
        this.data.valueRefs.push({id: 0, name: options[i]})
      }

      // // Sort options.
      // this.data.valueRefs.sort(function (a, b) {
      //   let aName = a.name.toUpperCase();
      //   let bName = b.name.toUpperCase();
      //   return aName === bName ? 0 : aName > bName ? 1 : -1;
      // })

      // Hide add option form.
      this.addTagOptionsVisible = false
    },
    onCancelAddTagOptions: function () {
      this.addTagOptionsVisible = false;
    },
    onRemoveOption: function (option) {
      let index = this.data.valueRefs.indexOf(option);
      this.data.valueRefs.splice(index, 1);
    }
  },
  computed: {
    title: function () {
      return this.isIdValid()
             ? this.pDictionary['dictionary.tag.udate.title']
             : this.pDictionary['dictionary.tag.create.title'];
    }
  },
  mounted: function () {
    let _component = this;

    let $bsTagFormDialog = $(_component.$refs.bsTagFormDialogRef);
    $bsTagFormDialog.on('shown.bs.modal', function () {

    });

    $bsTagFormDialog.on('hidden.bs.modal', function () {

    });

    $bsTagFormDialog.modal();
  }
}
</script>

<style scoped>

</style>